import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import OverviewComponent from './bodyDashboard/overview/OverviewComponent';
import SettingsComponent from './bodyDashboard/settings/SettingsComponent';
import LogingComponent from './bodyDashboard/logging/LogingComponent';
import StatusAntiWebhook from './bodyDashboard/antiWebhook/StatusAntiWebhook';
import LogsAntiWebHook from './bodyDashboard/antiWebhook/LogsAntiWebHook';
import StatusAntiSpam from './bodyDashboard/antiSpam/StatusAntiSpam';
import LogsAntiSpam from './bodyDashboard/antiSpam/LogsAntiSpam';
import StatusVerefication from './bodyDashboard/verefication/StatusVerefication';
import RulesVerefication from './bodyDashboard/verefication/RulesVerefication';
import CustomMassage from './bodyDashboard/verefication/CustomMassage/CustomMassage';
import LogsVerefication from './bodyDashboard/verefication/LogsVerefication';
import StatusAntiNuke from './bodyDashboard/antiNuke/StatusAntiNuke';
import LogsAntiNuke from './bodyDashboard/antiNuke/LogsAntiNuke';
import StatusFakeDetection from './bodyDashboard/fakeDetection/StatusFakeDetection';
import LogsFakeDetection from './bodyDashboard/fakeDetection/LogsFakeDetection';
import StatusAntiRaid from './bodyDashboard/antiRaid/StatusAntiRaid';
import LogsAntiRaid from './bodyDashboard/antiRaid/LogsAntiRaid';
import Premium from './bodyDashboard/premium';

import '../../styles/DashboardBody.scss';

const BodyDashboard = ({eqv, item}) => {
  const {overviewGlobalState} = useSelector((state) => state.overview);
  const guildName = overviewGlobalState?.data?.guild_name;
  const [activeComponent, setActiveComponent] = useState('Overview');
  const [previousComponent, setPreviousComponent] = useState('');

  useEffect(() => {
    if (eqv !== activeComponent) {
      setPreviousComponent(activeComponent);
      setTimeout(() => {
        setActiveComponent(eqv);
      }, 300);
    }
  }, [eqv]);

  const getComponentTransform = (componentName) => {
    if (componentName === activeComponent) return 'translateY(10%)';
    if (componentName === previousComponent) return 'translateY(-200%)';
    return 'translateY(200%)';
  };

  return (
    <div className="dashboadr_body_wrap">
      <div className="dashboadr_bread_crumbs">
        <h3>{guildName} / </h3>
        <h3>{eqv} / </h3>
      </div>
      <div
        className="animated-component animated-overview"
        style={{transform: getComponentTransform('Overview')}}>
        {activeComponent === 'Overview' || previousComponent === 'Overview' ? (
          <OverviewComponent eqv={eqv} item={item} overview={overviewGlobalState?.data} />
        ) : null}
      </div>
      <div
        className="animated-component animated-premium"
        style={{transform: getComponentTransform('Premium')}}>
        {activeComponent === 'Premium' || previousComponent === 'Premium' ? (
          <Premium eqv={eqv} item={item} />
        ) : null}
      </div>
      <div className="animated-component" style={{transform: getComponentTransform('Settings')}}>
        {activeComponent === 'Settings' || previousComponent === 'Settings' ? (
          <SettingsComponent eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component animated-component-logging"
        style={{transform: getComponentTransform('Logging')}}>
        {activeComponent === 'Logging' || previousComponent === 'Logging' ? (
          <LogingComponent eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component animated-component-logging-anti-webhook"
        style={{transform: getComponentTransform('Anti-Webhook-Status')}}>
        {activeComponent === 'Anti-Webhook-Status' ||
        previousComponent === 'Anti-Webhook-Status' ? (
          <StatusAntiWebhook eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{transform: getComponentTransform('Anti-Webhook-Logs')}}>
        {activeComponent === 'Anti-Webhook-Logs' || previousComponent === 'Anti-Webhook-Logs' ? (
          <LogsAntiWebHook eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component animated-component-anti-spam"
        style={{transform: getComponentTransform('Anti-Spam-Status')}}>
        {activeComponent === 'Anti-Spam-Status' || previousComponent === 'Anti-Spam-Status' ? (
          <StatusAntiSpam eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{transform: getComponentTransform('Anti-Spam-Logs')}}>
        {activeComponent === 'Anti-Spam-Logs' || previousComponent === 'Anti-Spam-Logs' ? (
          <LogsAntiSpam eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component animated-component-verefication"
        style={{transform: getComponentTransform('Verification-Status')}}>
        {activeComponent === 'Verification-Status' ||
        previousComponent === 'Verification-Status' ? (
          <StatusVerefication eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{transform: getComponentTransform('Verification-Rules')}}>
        {activeComponent === 'Verification-Rules' || previousComponent === 'Verification-Rules' ? (
          <RulesVerefication eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{
          transform: getComponentTransform('Verification-Custom Message'),
        }}>
        {activeComponent === 'Verification-Custom Message' ||
        previousComponent === 'Verification-Custom Message' ? (
          <CustomMassage eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{transform: getComponentTransform('Verification-Logs')}}>
        {activeComponent === 'Verification-Logs' || previousComponent === 'Verification-Logs' ? (
          <LogsVerefication eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component animated-component-anti-nuke"
        style={{transform: getComponentTransform('Anti-Nuke-Status')}}>
        {activeComponent === 'Anti-Nuke-Status' || previousComponent === 'Anti-Nuke-Status' ? (
          <StatusAntiNuke eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{transform: getComponentTransform('Anti-Nuke-Logs')}}>
        {activeComponent === 'Anti-Nuke-Logs' || previousComponent === 'Anti-Nuke-Logs' ? (
          <LogsAntiNuke eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component animated-component-fake-detection"
        style={{transform: getComponentTransform('Fake Detection-Status')}}>
        {activeComponent === 'Fake Detection-Status' ||
        previousComponent === 'Fake Detection-Status' ? (
          <StatusFakeDetection eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{transform: getComponentTransform('Fake Detection-Logs')}}>
        {activeComponent === 'Fake Detection-Logs' ||
        previousComponent === 'Fake Detection-Logs' ? (
          <LogsFakeDetection eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component animated-component-anti-raid"
        style={{transform: getComponentTransform('Anti-Raid-Status')}}>
        {activeComponent === 'Anti-Raid-Status' || previousComponent === 'Anti-Raid-Status' ? (
          <StatusAntiRaid eqv={eqv} item={item} />
        ) : null}
      </div>
      <div
        className="animated-component"
        style={{transform: getComponentTransform('Anti-Raid-Logs')}}>
        {activeComponent === 'Anti-Raid-Logs' || previousComponent === 'Anti-Raid-Logs' ? (
          <LogsAntiRaid eqv={eqv} item={item} />
        ) : null}
      </div>
    </div>
  );
};

export default BodyDashboard;
